import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { Analytics, getAnalytics, isSupported, logEvent } from 'firebase/analytics';

// Public Firebase web config (safe to commit — access is governed by
// Firestore security rules, not by this config).
const firebaseConfig = {
  apiKey: "AIzaSyCRtZ5TP1JVkV0eumK79wnYgZ0xzKuQwDY",
  authDomain: "oohdash-fb3ed.firebaseapp.com",
  projectId: "oohdash-fb3ed",
  storageBucket: "oohdash-fb3ed.firebasestorage.app",
  messagingSenderId: "253955748506",
  appId: "1:253955748506:web:d8c6e70cebba0a89ee2523",
  measurementId: "G-X5G5Z67D1F"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);

// Analytics init is async (isSupported() checks the runtime) and unavailable
// in unsupported environments (SSR, some sandboxes) — logScreenView no-ops
// until it resolves true.
let analytics: Analytics | undefined;
isSupported()
  .then(supported => {
    if (supported) analytics = getAnalytics(app);
  })
  .catch(() => {});

export const logScreenView = (screenName: string) => {
  if (!analytics) return;
  logEvent(analytics, 'screen_view', {
    firebase_screen: screenName,
    firebase_screen_class: screenName,
  });
};

export default app;
